module.exports = __webpack_public_path__ + "media/images/project-details-de6a4ff31716573548656f57fcfc59d7.webp";